"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function ownerDocument(node) {
    return (node && node.ownerDocument) || document;
}
exports.default = ownerDocument;
//# sourceMappingURL=ownerDocument.js.map